import logger from "@insite/client-framework/Logger";
import { del, get, patch, post, request } from "@insite/client-framework/Services/ApiService";
import { BaseModel } from "@insite/client-framework/Types/ApiModels";
import { ActiveQuoteTermParameter, QuoteTerm, QuoteTerms, QuoteTermState } from "@tKgpco/Store/Data/Terms/TermsState";

export interface AddTermApiParameters {
    TermsCode: string,
    Vendor: string,
    Type: string,
    Estimate: boolean,
    Description: string,
    Default: boolean,
    IsActive?: boolean
}

export interface ActivateQuoteTermModel extends BaseModel{
    id: string;
}
export interface AddQuoteTermCodeParameters {
    Id: string,
    TermsCode: string;
}
export interface UpdateTermApiParameters extends AddTermApiParameters {
    Id: string;
}

export const getTerms = async (paramaters?: any) => {
    const response = await get<QuoteTermState>("/api/v2/QuoteTerms/Get", paramaters);
    return response;
};

export const searchTermsApi = async (parameters: any) => {
    const response = await get<QuoteTerms>("/api/v2/QuoteTerms/Search", parameters);
    return response;
};

export const getTermById = async (id: string) => {
    const response = await get<QuoteTerm>(`/api/v2/QuoteTerms/${id}`);
    return response;
};

export const addTerm = async (parameters: AddTermApiParameters) => {
    const response = await post<AddTermApiParameters>("/api/v2/QuoteTerms/Create", parameters);
    return response;
};

export const updateTerm = async (parameters: UpdateTermApiParameters) => {
    const response = await put<UpdateTermApiParameters>("/api/v2/QuoteTerms/Update", parameters);
    return response;
};

export const deleteTerm = (id: string) => {
    return del(`/api/v2/QuoteTerms/${id}`);
};

export const uploadTermsApi = async (parameters: any) => {
    const formData = new FormData();
    formData.append("File", parameters.file);
    const response = await request<any>("/api/v2/QuoteTerms/Import", "POST", {}, formData);
    return response;
};

export const exportTermsApi = async (parameters: string[]) => {
    const response = await post<any>(`/api/v2/QuoteTerms/Export`, parameters);

    try {
        const blob = response.ok && (await response.blob());
        return blob;
    } catch (error) {
        logger.error(error);
    }
};

export const getTermCode = async () => {
    const response = await get<any>("/api/v2/QuoteTerms/GetWebTermsCode");
    return response;
};

export const addQuoteTermsCode = async (parameters: AddQuoteTermCodeParameters) => {
    const response = await post<AddQuoteTermCodeParameters>("/api/v2/QuoteTerms/AddQuoteTermsCode", parameters);
    return response;
};
export const activateTerm = async (parameters: ActiveQuoteTermParameter) => {
    const response =  await patch<ActivateQuoteTermModel>(`/api/v2/QuoteTerms/${parameters.id}`, parameters);
    return response;
}
function put<T>(endpoint: string, model: Partial<T> | T) {
    return request<T>(endpoint, "PUT", { "Content-Type": "application/json" }, JSON.stringify(model));
}
